/* ============================================================
   The shop's owner heads every list of its people.

   Registration writes the owner into shop.staffs first, but that array
   is rebuilt whenever the roster changes — inviting, removing, or
   handing a calendar over and taking it back — so the position is
   enforced at render time rather than trusted. Shops that went through
   one of those cycles already have the owner sitting further down.
   ============================================================ */

/** Is this row the shop's owner?
 *
 * Matched on ownerId first, with a role fallback: an invited row carries a
 * role but has no userId until that person finishes registering. */
export const isOwnerRow = (shop, person) =>
	Boolean((shop?.ownerId && person?.userId && person.userId === shop.ownerId) || person?.role === "owner");

/** Owner first, everyone else in the order the shop already had them.
 *  Array.prototype.sort is stable, so no other row moves. */
export const ownerFirst = (shop, people) =>
	[...(people || [])].sort((a, b) => Number(isOwnerRow(shop, b)) - Number(isOwnerRow(shop, a)));

export default ownerFirst;
